<template>
	<h-switch
		v-slot="{checked}"
		v-model="isChecked"
		:value="item.id"
		class="ring-focus group flex cursor-pointer items-center space-x-2 text-left text-sm outline-hidden focus:ring-offset-2"
	>
		<span
			class="flex size-4 items-center justify-center rounded text-white transition-colors duration-150"
			:class="{
				'bg-black': checked,
				'border-2 border-solid border-gray-100': !checked,
			}"
		>
			<transition
				enter-active-class="transition-opacity duration-150"
				enter-from-class="opacity-0"
				enter-to-class="opacity-100"
				leave-active-class="transition-opacity duration-150"
				leave-from-class="opacity-100"
				leave-to-class="opacity-0"
			>
				<v-icon icon="check" class="text-xs"></v-icon>
			</transition>
		</span>

		<span v-if="'color' in item">
			<span
				class="-mr-0.5 inline-block size-3 rounded-full border border-solid border-gray-300 bg-(--color)"
				:style="{'--color': item.color}"
			/>
		</span>

		<span>
			{{ item.label }}
		</span>
	</h-switch>
</template>

<script lang="ts" setup>
import type {TextFacetValue, ColorFacetValue} from "@apptus/esales-api";
import {useVModel} from "@vueuse/core";

const properties = defineProps<{
	item: TextFacetValue | ColorFacetValue;
	modelValue?: (string | number | boolean)[];
}>();

const emit = defineEmits<{
	(event: "update:modelValue", value?: (string | number | boolean)[]): void;
}>();

const selectedItems = useVModel(properties, "modelValue", emit);

const isChecked = computed<boolean>({
	get() {
		return selectedItems.value?.includes(properties.item.id) || false;
	},
	set(value) {
		selectedItems.value = value
			? [...(selectedItems.value || []), properties.item.id]
			: selectedItems.value?.filter((item) => item !== properties.item.id) ||
				[];
	},
});
</script>
